import type { ChipOption } from "$routes/patient/[:patientId]/_lib/text-input-with-selectable-options";
import { AddVaccinationCard } from "$routes/patient/[:patientId]/vaccinations/new/_lib/add-vaccination-card";
import { styled } from "@material-ui/core";
import { useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import { useWeightAndAllergies } from "../../../patient/_lib/use-weight-and-allergies";
import { Form } from "./_form";

const Container = styled("div")(({ theme }) => ({
  padding: 20,
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2),
  alignItems: "center",
}));

export const PatientAddConsultationPage: FC = () => {
  const { patientId } = useParams();
  const { weight, allergies } = useWeightAndAllergies({ patientId });
  const methods = useForm({
    defaultValues: {
      vaccinations: [],
    },
  });

  const [chips, setChips] = useState<ChipOption[]>([]);
  const addChip = (chip: ChipOption) => {
    setChips((prevChips) => [...prevChips, chip]);
  };

  const removeChip = (index: number) => {
    setChips((prevChips) => prevChips.filter((_, i) => i !== index));
  };

  return (
    <Container>
      <Form
        patientAllergies={allergies}
        patientWeight={weight ? `${weight}` : null}
      />
      <div style={{ width: "600px" }}>
        <FormProvider {...methods}>
          <form style={{ padding: "20px" }}>
            <AddVaccinationCard
              patientId={patientId}
              fieldName="vaccinations"
              recommendedVaccinations={[
                { id: "1", code: "$IMM1" },
                { id: "2", code: "$IMM10" },
                { id: "3", code: "$IMM11" },
              ].filter(
                (option) => !chips.some((chip) => chip.optionId === option.id),
              )}
              vaccinations={chips.map((chip) => ({
                code: chip.optionId,
              }))}
              addVaccination={addChip}
              removeVaccination={removeChip}
            />
          </form>
        </FormProvider>
      </div>
    </Container>
  );
};
